<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.reservation.actions.undoNoShow.title')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('components.reservation.actions.undoNoShow.confirm'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Reservation } from '~/_api/models/reservation'

interface Props {
  reservation?: Reservation | null
  portal?: string | null
  loading?: boolean
}

interface Emits {
  (e: 'update:reservation', value: Reservation): void
  (e: 'update:loading', value: boolean): void
}

const props = withDefaults(defineProps<Props>(), {
  reservation: null,
  portal: null,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()

const info = computed(() => {
  return $i18n.t('components.reservation.actions.undoNoShow.info', { name: (props.reservation as any)?.customer?.displayName })
})

const open = () => {
  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const reservation = props.reservation as any
    const isAttendee = reservation?.idReservationCustomer != null
    const reservationId = reservation?.idReservation?.toString()
    const reservationCustomerId = reservation?.idReservationCustomer?.toString()
    const response = isAttendee
      ? await $api.reservationCustomer.unDidNotShow(reservationCustomerId)
      : await $api.reservation.unDidNotShow(reservationId)

    if (response.data) {
      emit('update:reservation', response.data)
      emit('update:loading', false)

      $notification.toast({
        title: $i18n.t('components.reservation.actions.undoCheckInSuccess'),
        text: $i18n.t('components.reservation.actions.undoCheckInSuccessInfo', { name: (props.reservation as any)?.customer?.displayName }),
        variant: 'success',
      })

      return true
    }
  } catch (e: any) {
    console.log(e)
  }

  emit('update:loading', false)
}

defineExpose({ open })
</script>
